/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';

import AgreementsService from 'services/agreements.service';
import {IPageResponse, SortDirection} from "../../common/interfaces/IPageResponse";
import {AgreementSigningStatus, AGREEMENT_SIGNING_STATUS_MAP, AGREEMENT_TYPE_MAP, IAgreement, IAgreementRequest, IAgreementsSortFields} from "../../models/agreements";
import {CustomerPermission, InitContextProps, useAuthContext} from "../../services/context/authentication.context";
import AgreementSigningModal from 'components/Modals/AgreementSigningModal/AgreementSigningModal';
import {canSignAgreement} from 'helpers/signer-helper';

export function NewAgreements() {
  const [agreements, setAgreements]: [Array<IAgreement>, any] = useState([]);
  const [request]: [IAgreementRequest, any] = useState({
    size: 3,
    page: 0,
    sortDirection: SortDirection.ASC,
    sortField: IAgreementsSortFields.DATE_MODIFIED,
        statuses: 'PREPARED,PENDING_CUSTOMER'
  });
  const { state, hasPermission }: InitContextProps = useAuthContext();
    const {customerId} = state;
    const [selectedAgreement, selectAgreement] = useState<IAgreement | null>(null);

  useEffect(() => {
    if (customerId !== null) {
            AgreementsService.getAgreements(customerId, request).then((res: IPageResponse<IAgreement>) => {
                setAgreements(res.content.filter(a => !a.isSignedByCustomer));
            });
    }
  }, [customerId]);

  const onSigningSubmitSuccess = () => {
    if (customerId !== null) {
            AgreementsService.getAgreements(customerId, request).then((res: IPageResponse<IAgreement>) => {
          setAgreements(res.content);
            });
      selectAgreement(null);
    }
    }
  const getAgreementFile = async (agreement: IAgreement, type: 'PDF' | 'BDOC') => {
      if (customerId === null)
          return;

      await AgreementsService.getAgreementFileWithDownload(agreement.id, type);
  }

  return (
    <>
        { agreements && agreements.length ?
        <div className='new-agreements__container'>
            <h2 className='u-fs-20 mb-3'>
                UUED LEPINGUD
            </h2>
            <div className='new-agreements__card-container'>
                {agreements.map((newAgreement) =>
                    <div key={"newAgreement_" + newAgreement.id} className='new-agreements__card'>
                <div className="card__description">
                            <h4 className="cursor-pointer" onClick={() => getAgreementFile(newAgreement, 'PDF')}>
                    Leping {newAgreement.contractNumber}
                  </h4>
                            <p className='card__agreement-type'>
                                    { AGREEMENT_TYPE_MAP[newAgreement.type] }
                  </p>
                </div>
                <div className='card__end agreements__status'>
                  {
                    !newAgreement.isSignedByCustomer ?
                      (
                        <>
                          {
                            hasPermission(CustomerPermission.WEB_ADMIN)
                            && canSignAgreement(newAgreement, state.user?.personalIdentificationCode) ? (
                              <button className='btn btn-outline-primary' onClick={() => selectAgreement(newAgreement)}>
                                Lisa allkiri
                              </button>
                            ) : null
                          }
                        </>
                      ) :
                      <SigningStatusLabel agreement={newAgreement} />
                  }
                </div>
              </div>
                )}
          </div>
            {
            selectedAgreement &&
            <AgreementSigningModal
              handleModalHide={() => selectAgreement(null)}
              onSubmitSuccess={() => onSigningSubmitSuccess()}
                    agreement={selectedAgreement} />
            }            
        </div>
        : null }
    </>
    )
}

export const SigningStatusLabel = ({ agreement }: { agreement: IAgreement }) => {

  let className = 'client-status';
  const signingStatus = AgreementsService.getSigningStatus(agreement);
  if (signingStatus === AgreementSigningStatus.PREPARED) {
    className = 'prepared-status';
  } else if (signingStatus === AgreementSigningStatus.COMPLETED) {
    className = 'signed-status';
  }

  return (
    <div className={className}>
        { AGREEMENT_SIGNING_STATUS_MAP[signingStatus] }
    </div>
    )

}